import React from 'react';
import { Alert } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';

const SubscriptionUpgradeLink = ({ 
    serverWaitingCount, 
    loginInfo, 
    onUpgradeClick,
    compact = false,
    className = ""
}) => {
    // 表示条件をチェック
    if (!serverWaitingCount || serverWaitingCount <= 0 || !loginInfo || !loginInfo.result || loginInfo.plan !== "") {
        return null;
    }

    const handleMouseEnter = (e) => {
        e.currentTarget.style.backgroundColor = "#cce7ff";
        e.currentTarget.style.transform = "translateY(-1px)";
        e.currentTarget.style.boxShadow = "0 2px 4px rgba(0,0,0,0.1)";
    };

    const handleMouseLeave = (e) => {
        e.currentTarget.style.backgroundColor = "#e7f3ff";
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow = "none";
    };

    const baseStyle = {
        cursor: "pointer", 
        border: "2px solid #0dcaf0", 
        borderRadius: "8px", 
        backgroundColor: "#e7f3ff",
        transition: "all 0.3s ease",
        padding: compact ? "2px 6px" : "4px 8px",
        margin: "4px 0",
        maxWidth: compact ? "240px" : "280px",
        fontSize: compact ? "10px" : "11px",
    };

    const iconSize = compact ? "10px" : "12px";
    const iconMargin = compact ? "2px" : "4px";

    return (
        <Alert 
            variant="info" 
            className={`d-flex justify-content-center align-items-center subscription-upgrade-link ${className}`}
            style={baseStyle}
            onClick={onUpgradeClick}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <Icon.StarFill 
                style={{
                    color: "#ffd700", 
                    fontSize: iconSize, 
                    marginRight: iconMargin
                }} 
            />
            <span 
                style={{
                    fontWeight: "bold", 
                    color: "#0d6efd", 
                    whiteSpace: "nowrap"
                }}
            >
                {compact ? "プラン加入" : "プラン加入で優先度UP"}
            </span>
            <Icon.ArrowRight 
                style={{
                    color: "#0d6efd", 
                    fontSize: iconSize, 
                    marginLeft: iconMargin
                }} 
            />
        </Alert>
    );
};

export default SubscriptionUpgradeLink;
